// RealTimeViewer.tsx

import { getRealTimeData } from "@/pages/caster/repositories/ProductionRepository";
import { ErrorModal, useShiftNavigator } from "@dexteel/mesf-core";
import { Paper, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useState, useEffect } from "react";

export interface RealTimeData {
	ShiftId: number;
	CASTonsPerHour: number;
	CASTons: number;
}

const RealTimeViewer: React.FC = () => {
	const [error, setError] = useState<string>("");
	const { shiftInfo } = useShiftNavigator();

	const [realTimeData, setRealTimeData] = useState<RealTimeData | null>(null);

	const fetchRealTimeData = async () => {
		if (shiftInfo) {
			const resp = await getRealTimeData(shiftInfo.CurrentShiftId);
			if (resp.ok) {
				setRealTimeData(resp.data.tables[0].rows[0]);
			} else {
				setError(resp.message);
			}
		}
	};

	useEffect(() => {
		if (!shiftInfo) return;
		fetchRealTimeData();

		let intervalId: NodeJS.Timeout | undefined;
		if (shiftInfo.CurrentShiftId === shiftInfo.LastShiftId) {
			intervalId = setInterval(() => {
				fetchRealTimeData();
			}, 120000); // 2 minutes
		}

		return () => {
			if (intervalId) clearInterval(intervalId);
		};
	}, [shiftInfo]);

	return (
		<>
			<Paper
				style={{
					display: "flex",
					justifyContent: "center",
					padding: "9px",
					width: "auto",
				}}
			>
				<Grid container spacing={1}>
					<Grid size={{ xs: 6 }}>
						<TextField
							fullWidth
							size="small"
							disabled
							label="Cast Tons/hour"
							variant="outlined"
							value={
								realTimeData ? realTimeData.CASTonsPerHour?.toFixed(2) : "-"
							}
							style={{ minWidth: "50px" }}
							InputLabelProps={{ shrink: true }}
						/>
					</Grid>
					<Grid size={{ xs: 6 }}>
						<TextField
							fullWidth
							size="small"
							disabled
							label="Cast Tons"
							variant="outlined"
							value={realTimeData ? realTimeData.CASTons?.toFixed(2) : "-"}
							style={{ minWidth: "50px" }}
							InputLabelProps={{ shrink: true }}
						/>
					</Grid>
				</Grid>
			</Paper>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};

export default RealTimeViewer;
